/* eslint-disable react/jsx-props-no-spreading */
import { FC, RefAttributes } from 'react'
import { RowDataType, RowKeyType, Cell as RsuiteCell } from 'rsuite-table'
import { InnerCellProps } from 'rsuite-table/lib/Cell'
import { Whisper, Tooltip } from 'rsuite'

type Props = InnerCellProps<RowDataType<any>, RowKeyType> &
  RefAttributes<HTMLDivElement> & {
    /**
     * Tooltip text. Pass a string for a static label or a function for
     * per-row text. When omitted the cell auto-derives text from dataKey.
     * Pass an empty string `""` to explicitly suppress the tooltip.
     */
    tooltip?: string | ((rowData: any) => string);
  }

const Cell: FC<Props> = ({ dataKey, rowData, tooltip, children, ...props }: Props) => {
  const autoText = rowData && dataKey ? String(rowData[dataKey] ?? '') : ''

  let tooltipText: string
  if (typeof tooltip === 'function') {
    tooltipText = rowData ? tooltip(rowData) : ''
  } else {
    tooltipText = tooltip !== undefined ? tooltip : autoText
  }

  const cell = (
    <RsuiteCell dataKey={dataKey} rowData={rowData} {...props}>
      {children}
    </RsuiteCell>
  )

  if (!tooltipText) return cell

  return (
    <Whisper
      placement="bottom"
      trigger="hover"
      speaker={<Tooltip>{tooltipText}</Tooltip>}
    >
      {cell}
    </Whisper>
  )
}

export default Cell
